import React from "react";
import { Col, FormControl, FormLabel, Row } from "react-bootstrap";
import { CustomerTopSection } from "./customer-top-section";

const AddressFields = ({ prefix, quote, countries, handleChange }) => {
    const fields = [
        { key: "CompanyName", label: "Company", required: true },
        { key: "Address1", label: "Address line 1", required: true },
        { key: "Address2", label: "Address line 2", optional: true },
        { key: "City", label: "City", required: true },
        { key: "State", label: "State / province", required: true },
        { key: "PostalCode", label: "Postal code", optional: true },
        { key: "PhoneNumber", label: "Phone number", required: true },
    ];

    return (
        <Row>
            {fields.map((field) => {
                const name = `${prefix}${field.key}`;
                const wide = field.key.indexOf("Address") === 0 || field.key === "CompanyName";
                return (
                    <Col md={wide ? 12 : 6} className="mb-3" key={name}>
                        <FormLabel htmlFor={name}>
                            {field.label} {field.required && <span aria-hidden="true">*</span>}
                            {field.optional && <span className="field-optional">Optional</span>}
                        </FormLabel>
                        <FormControl
                            id={name}
                            name={name}
                            type={field.key === "PhoneNumber" ? "tel" : "text"}
                            className="form-control custom-input"
                            value={quote[name] || ""}
                            onChange={handleChange}
                            required={field.required}
                            placeholder={field.label}
                        />
                    </Col>
                );
            })}
            <Col md="12" className="mb-3">
                <FormLabel htmlFor={`${prefix}Country`}>Country <span aria-hidden="true">*</span></FormLabel>
                <FormControl
                    as="select"
                    required
                    id={`${prefix}Country`}
                    name={`${prefix}Country`}
                    className="form-control"
                    value={quote[`${prefix}Country`] || ""}
                    onChange={handleChange}>
                    <option value="">Select country</option>
                    {countries && countries.map((country) => (
                        <option key={country.code} value={country.code}>{country.name}</option>
                    ))}
                </FormControl>
            </Col>
        </Row>
    );
};

export const QuoteDetailsStep = ({
    quote,
    countries,
    endUsers,
    sameAsBilling,
    handleChange,
    handleEndUserChange,
    handleOpen,
    sameAsShipping,
}) => (
    <div className="quote-step-content">
        <section className="quote-section" aria-labelledby="customer-heading">
            <div className="section-heading">
                <div>
                    <span className="section-kicker">Customer</span>
                    <h2 id="customer-heading">Who is this quote for?</h2>
                </div>
                <p>Fields marked * are required.</p>
            </div>
            <CustomerTopSection
                quote={quote}
                handleChange={handleChange}
                endUsersArray={endUsers}
                handleEndUserChange={handleEndUserChange}
                handleOpen={handleOpen}
            />
        </section>

        <section className="quote-section" aria-labelledby="shipping-heading">
            <div className="section-heading">
                <div>
                    <span className="section-kicker">Delivery</span>
                    <h2 id="shipping-heading">Shipping address</h2>
                </div>
            </div>
            <AddressFields prefix="Ship" quote={quote} countries={countries} handleChange={handleChange} />
        </section>

        <section className="quote-section billing-section" aria-labelledby="billing-heading">
            <div className="section-heading billing-heading">
                <div>
                    <span className="section-kicker">Billing</span>
                    <h2 id="billing-heading">Billing address</h2>
                </div>
                <label className="same-address-control" htmlFor="sameAsShipping">
                    <input
                        id="sameAsShipping"
                        name="sameAsShipping"
                        type="checkbox"
                        checked={sameAsBilling}
                        onChange={sameAsShipping}
                    />
                    Same as shipping
                </label>
            </div>
            {!sameAsBilling && (
                <AddressFields prefix="Billing" quote={quote} countries={countries} handleChange={handleChange} />
            )}
            {sameAsBilling && <p className="collapsed-section-note">Billing details will match the shipping address.</p>}
        </section>

        <details className="quote-section optional-details">
            <summary>
                <span>
                    <span className="section-kicker">Optional</span>
                    <strong>Additional quote notes</strong>
                </span>
                <i className="fa fa-chevron-down" aria-hidden="true"></i>
            </summary>
            <div className="optional-details-body">
                <FormLabel htmlFor="Quote_Comments">Notes for the IntrepidCS team</FormLabel>
                <FormControl
                    id="Quote_Comments"
                    as="textarea"
                    name="Quote_Comments"
                    rows={5}
                    onChange={handleChange}
                    value={quote.Quote_Comments ? quote.Quote_Comments.replace(/(<([^>]+)>)/gi, "") : ""}
                    placeholder="Add context, delivery requirements, or other details"
                />
            </div>
        </details>
    </div>
);
